export const data = [
  {
    id: "2343",
    name: "Ikeja shop",
    address: "shop 2, opebi street",
    sales: "67",
    date: `${new Date()}`,
  },
];
